import { render } from "./Logo.vue?vue&type=template&id=c07e4856&scoped=true"
import script from "./Logo.vue?vue&type=script&lang=ts"
export * from "./Logo.vue?vue&type=script&lang=ts"

import "./Logo.vue?vue&type=style&index=0&id=c07e4856&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c07e4856"

export default script